
(function lawBookControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookEditController', [
            '$scope', 'config', '$state', '$stateParams', '$window', 'errorsExtend', 'documentService', 'documentTypeService', 'auth', 'authExtend', 'storageService', 'fileService', '$q', '$filter',
            function lawBookAddController($scope, config, $state, $stateParams, $window, errors, documentService, documentTypeService, auth, authExtend, storageService, fileService, $q, $filter) {
                $scope.loading = true;
                $scope.files = {
                    requireSignatureSelection: [],
                    attachedSelection: []
                };

                $scope.loadDocumentType = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    documentTypeService.getBySystemName($scope.lawBookSystemName, 'Detail', 'LAWBOOK WRITE').then(function (result) {
                        defered.resolve(result);
                    }, function (error) {
                        errors.showError(error);
                        defered.reject(error);
                    });

                    return promise;
                };

                $scope.loadDocument = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    documentService.checkoutWithExpiration($stateParams.id).then(function (result) {
                        defered.resolve(result);
                    }, function (error) {
                        errors.showError(error);
                        defered.reject(error);
                    });

                    return promise;
                };

                $scope.loadMetadatas = function (metadatas, metadataValues) {
                    metadatas.forEach(function (metadata) {
                        if (metadata.isEnabled) {
                            var mValueResult = $filter('filter')(metadataValues, { metadataId: metadata.metadataId }, true);

                            if (metadata.metadataSystemName === '_estadoLLS' && mValueResult.length > 0 && (mValueResult[0].metadataValue === '06' || mValueResult[0].metadataValue === 'E')) {
                                errors.showError('LawBookNoEditState');
                                $scope.cancel();
                            }

                            $scope.document.documentTypes[0].metadatas.push({
                                idObject: $scope.document.documentTypes[0].documentTypeId + '' + metadata.metadataId,
                                metadataId: metadata.metadataId,
                                metadataIsRequired: metadata.isRequired,
                                metadataIsUnique: metadata.isUnique,
                                metadataEnabled: true,
                                metadataReadOnly: true,
                                metadataValue: mValueResult.length > 0 ? mValueResult[0].metadataValue : '',
                                metadataType: metadata.metadataType,
                                metadataSystemName: metadata.metadataSystemName,
                                metadataLabel: metadata.metadataLabel,
                                metadataOptions: metadata.optionValues,
                                maskOptions: metadata.maskOptions,
                                metadataAsName: metadata.asName,
                                metadataIsMultivalue: metadata.isMultivalue,
                                metadataIsAutoComplete: metadata.metadataSystemName === '_estadoLLS' || metadata.metadataSystemName === '_tnomina'
                            });
                        }
                    });
                };

                $scope.loadFiles = function (document) {
                    if (document.files && document.files.length > 0) {

                        for (var i = 0; i < document.files.length; i++) {
                            document.files[i].fsize = fileService.FormatfileSize(document.files[i].size);
                            if (document.files[i].maxSigners > 0) {
                                $scope.files.requireSignatureList.push(document.files[i]);
                                $scope.files.requireSignatureListOpen = true;
                            } else {
                                $scope.files.attachedList.push(document.files[i]);
                                $scope.files.attachedListOpen = true;
                            }
                        }
                    }
                };

                $scope.addSignedFile = function () {
                    $scope.files.requireSignatureSelection.forEach(function (file) {
                        if (file && file.size && file.name && file.name.toLowerCase().indexOf(".pdf") > 0) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var fileExist = $filter('filter')($scope.files.requireSignatureList, { name: file.name }, true);
                            if (fileExist && fileExist.length > 0) {
                                errors.showError('LawBookFileExist');
                            }
                            var index = $scope.getIndexFile(file, $scope.files.requireSignatureList);
                            if (!~index) {
                                var indexAux = $scope.getIndexFile(file, $scope.files.attachedList);
                                if (indexAux === -1) {
                                    $scope.files.requireSignatureList.push(file);
                                } else {
                                    errors.showError('AddSignedFileError');
                                }
                            }

                            $scope.files.requireSignatureListOpen = true;
                        }
                    });

                    $scope.files.requireSignatureSelection = [];
                };

                $scope.removeSignedFile = function (file) {
                    var index = $scope.getIndexFile(file, $scope.files.requireSignatureList);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }

                        $scope.files.requireSignatureList.splice(index, 1);
                    }
                }

                $scope.addAttachedFile = function () {
                    $scope.files.attachedSelection.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file, $scope.files.attachedList);
                            if (!~index) {
                                var indexAux = $scope.getIndexFile(file, $scope.files.requireSignatureList);
                                if (indexAux === -1) {
                                    $scope.files.attachedList.push(file);
                                } else {
                                    errors.showError('AddAttachedFileError');
                                }
                            }

                            $scope.files.attachedListOpen = true;
                        }
                    });

                    $scope.files.attachedSelection = [];
                };

                $scope.removeAttachedFile = function (file) {
                    var index = $scope.getIndexFile(file, $scope.files.attachedList);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }

                        $scope.files.attachedList.splice(index, 1);
                    }
                };

                $scope.getIndexFile = function (fileNew, collection) {
                    for (var i in collection) {
                        if (collection.hasOwnProperty(i)) {
                            var fileOld = collection[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;
                    $scope.files.requireSignatureListOpen = false;
                    $scope.files.attachedListOpen = false;

                    fileService.preview(item, true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        } else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                };

                $scope.hidePreview = function () {

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };

                    $scope.files.requireSignatureListOpen = true;
                    $scope.files.attachedListOpen = true;
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if (!$scope.preview.item.maxSigners || $scope.preview.item.maxSigners === 0) {
                            if ($scope.preview.index + 1 < $scope.files.attachedList.length) {
                                $scope.preview.index++;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        } else {
                            if ($scope.preview.index + 1 < $scope.files.requireSignatureList.length) {
                                $scope.preview.index++;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            } else {
                                $scope.preview.index = 0;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        }
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if ($scope.preview.item.maxSigners > 0) {
                            if ($scope.preview.index >= 0 && $scope.preview.index < $scope.files.requireSignatureList.length) {
                                $scope.preview.index--;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            }
                        } else {
                            if ($scope.preview.index == 0) {
                                $scope.preview.index = $scope.files.requireSignatureList.length - 1;
                                $scope.previewFile($scope.files.requireSignatureList[$scope.preview.index], $scope.preview.index);
                            } else {
                                $scope.preview.index--;
                                $scope.previewFile($scope.files.attachedList[$scope.preview.index], $scope.preview.index);
                            }
                        }
                    }
                };

                $scope.nextDisabled = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if ((!$scope.preview.item.maxSigners || $scope.preview.item.maxSigners === 0) && $scope.preview.index == $scope.files.attachedList.length - 1) {
                            return true;
                        } else if ($scope.files.requireSignatureList.length > 0 &&
                            $scope.files.attachedList.length == 0 && $scope.preview.index == $scope.files.requireSignatureList.length - 1) {
                            return true;
                        }
                    }

                    return false;
                }

                $scope.prevDisabled = function () {
                    if ($scope.preview.item && $scope.preview.index != null) {
                        if ($scope.preview.item.maxSigners > 0 && $scope.preview.index == 0) {
                            return true;
                        } else if ($scope.files.requireSignatureList.length == 0 &&
                            $scope.files.attachedList.length > 0 && $scope.preview.index == 0) {
                            return true;
                        }
                    }

                    return false;
                }

                $scope.metadataCount = function () {
                    return $scope.document.documentTypes[0].metadatas.length;
                }

                $scope.cancel = function () {
                    documentService.deleteVersion($scope.document);
                    $window.history.back();
                };

                $scope.save = function () {
                    if ($scope.loading)
                        return;

                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    var files = [];
                    $scope.document.files = [];

                    $scope.document.singData = {};

                    $scope.files.requireSignatureList.forEach(function (file) {
                        $scope.document.singData[file.name] = 1;
                    });

                    $scope.files.requireSignatureList.forEach(function (file) {
                        if (file.id && file.id > 0) {
                            $scope.document.files.push(file);
                        } else {
                            files.push(file);
                        }
                    });

                    $scope.files.attachedList.forEach(function (file) {
                        if (file.id && file.id > 0) {
                            $scope.document.files.push(file);
                        } else {
                            files.push(file);
                        }
                    });
                    $scope.loading = true;

                    $scope.loading = true;
                    return documentService.modifyAndCheckin($scope.document, files)
                        .then(function (result) {
                            $scope.loading = false;

                            if (result && result.status === 200 && result.data) {
                                $state.go('lawbook-find');
                            }
                        }, function (error) {
                            $scope.loading = false;
                            errors.showError(error);
                        });
                };

                $scope.load = function () {
                    $scope.lawBookSystemName = '_ley';

                    $scope.document = {
                        name: '',
                        documentTypes: [],
                        categories: [],
                        containers: [],
                        organizationalUnitId: auth.getOrganizationId(),
                        isDocumentPerFile: false
                    };

                    $scope.files = {
                        requireSignatureSelection: [],
                        requireSignatureList: [],
                        requireSignatureListOpen: false,
                        attachedSelection: [],
                        attachedList: [],
                        attachedListOpen: false
                    };

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        item: null,
                        invalid: false
                    };

                    $q.all([$scope.loadDocumentType(), $scope.loadDocument()]).then(function (result) {
                        if (result && result.length == 2) {
                            if (result[1].documentTypes && result[1].documentTypes.length == 0) {
                                error.showError('NoDocumentTypeOrDocument');
                                $scope.cancel();
                            }

                            $scope.document.id = $stateParams.id;
                            $scope.document.name = result[1].name;
                            $scope.document.documentId = result[1].documentId;
                            $scope.document.versionId = result[1].versionId;
                            $scope.document.documentTypes.push({
                                documentTypeId: result[0].id,
                                documentTypeName: result[0].name,
                                metadatas: []
                            });

                            $scope.loadMetadatas(result[0].metadata, result[1].documentTypes[0].metadatas);
                            $scope.loadFiles(result[1]);

                            $scope.loading = false;
                        } else {
                            $scope.loading = false;
                            error.showError('NoDocumentTypeOrDocument');
                            $scope.cancel();

                        }
                    }, function (error) {
                        $scope.loading = false;
                        $scope.cancel();
                    });
                };

                $scope.load();
            }
        ]);
})();